var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('RootLayout',{staticClass:"height-100"}),(_vm.hasFooter)?_c('NewFooter'):_vm._e(),(_vm.mode !== 'production')?_c('Errors'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }